import React from 'react';
import { observer } from 'mobx-react-lite';
import { Collapse, IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib';
import { IMSicSearch } from '@insurancemenu/imenu-components-lib/dist/components/imForm/capabilities/sic/IMSicSearch';
import SectionTitle from 'components/common/general/SectionTitle';
import DomainProductLines from 'components/common/initiate-proposal/DomainProductLines';
import {
  FollowingSectionTitleStyled,
  IMZipCodeFieldStyled,
  IMZipCountyFieldStyled,
  IMZipStateFieldStyled,
  TabIMFormStyled,
  AlertStyled,
  SICWrapperStyled,
} from 'components/common/initiate-proposal/styles';
import BasicInfoStepController from 'store/pages/initiate-quote/ddnj/step-controllers/basicInfoStepController';
import { DDNJ_INITIATE_PROPOSAL_FORM_ID, DDNJ_SIC_WARNING_ALERT_TEST_ID } from './constants';

interface Props {
  basicInfoStepController: BasicInfoStepController;
}

const DDNJBasicInfoStep: React.FC<Props> = observer(({ basicInfoStepController }) => {
  const { form, effectiveDatesOptions, domainProductLineItems, isDomainProductLinesLoading, sicWarningMessage } =
    basicInfoStepController;

  const showWarning = Boolean(sicWarningMessage);

  return (
    <TabIMFormStyled id={DDNJ_INITIATE_PROPOSAL_FORM_ID} formController={form}>
      <SectionTitle title="Basic Information" />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesOptions} />
      <IMZipCodeFieldStyled size="s" />
      <IMZipStateFieldStyled size="s" />
      <IMZipCountyFieldStyled size="s" />

      <FollowingSectionTitleStyled title="Additional Information" />
      <SICWrapperStyled>
        <IMSicSearch label="SIC Code" size="full" />
        <Collapse show={showWarning}>
          <AlertStyled
            content={[sicWarningMessage]}
            title="Note"
            type="warning"
            data-test-id={DDNJ_SIC_WARNING_ALERT_TEST_ID}
          />
        </Collapse>
      </SICWrapperStyled>

      <FollowingSectionTitleStyled title="Available Product Lines" />
      <DomainProductLines domainProductLineItems={domainProductLineItems} isLoading={isDomainProductLinesLoading} />
    </TabIMFormStyled>
  );
});

export default DDNJBasicInfoStep;
